// extracted by mini-css-extract-plugin
export var addressFields = "_oj-0";
export var animationContainer = "_oj-1";
export var footer = "_oj-2";
export var lineItems = "_oj-3";
export var modalContent = "_oj-4";
export var orderName = "_oj-5";
export var strong = "_oj-6";
export var warning = "_oj-7";